module.exports = __webpack_public_path__ + "img/fzy.542cef54.jpg";